import { render } from "./LikeAnimation.vue?vue&type=template&id=544ae015"
import script from "./LikeAnimation.vue?vue&type=script&lang=js"
export * from "./LikeAnimation.vue?vue&type=script&lang=js"

import "./LikeAnimation.vue?vue&type=style&index=0&id=544ae015&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__